<template>
  <div class="form-block" :class="{'form-block--warning': validationError}">
    <div class="form-block-inner">
      <label>{{field.label}}</label>
      <RichEditor v-if="field.value !== ''" :initValue="field.value" @change="changed"></RichEditor>
      <RichEditor v-else :initValue="field.defaultValue" @change="changed"></RichEditor>
    </div>
    <div class="form-error" v-if="validationError">
      <i class="icon-error"></i> {{field.name}} is required
    </div>
  </div>
</template>

<script>
import RichEditor from "@/components/general/RichEditor";
export default {
  name: "RichTextField",
  props:['field', 'validationError'],
  components: {RichEditor},
  methods: {
    changed(val) {
      this.field.value = val;
      this.$emit('changed');
    }
  }
}
</script>

<style scoped>

</style>
